import { CssStates, embeddedImagesBase64, IGrapesJSProjectData, SmartIdentifierStates } from "../../../interfaces/VisageUI";
import { GjsAttributeNames } from "../gjsplugin/Enums";

const GjsTemplateContent: IGrapesJSProjectData = {
	"assets":[

	],
	"styles":[
		{
			"selectors":[

			],
			"selectorsAdd":"body",
			"style":{
				"width":"100vw",
				"height":"100vh",
				"background-color":"transparent"
			}
		},
		{
			"selectors":[
				"gjs-plh-image"
			],
			"style":{
				"background-image":"none",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"outline-color":"initial",
				"outline-style":"none",
				"outline-width":"initial"
			}
		},
		{
			"selectors":[
				"#Cf3d3d78b-3ad4-4afd-a1b7-b2fe41d9c616"
			],
			"style":{
				"width":"100%",
				"height":"100%",
				"display":"flex",
				"align-content":"center",
				"align-items":"center",
				"flex-direction":"column",
				"justify-content":"flex-start",
				"padding-top":"0vw",
				"padding-bottom":"0vw"
			}
		},
		{
			"selectors":[
				"#C021d6e69-2e9d-4922-8c7e-a6ee36772440-11"
			],
			"style":{
				"background":"rgba(30, 30, 30, 0.9)",
				"max-width":"76vw",
				"display":"flex",
				"padding-top":"0vw",
				"padding-right":"1.5vw",
				"padding-bottom":"1.5vw",
				"padding-left":"1.5vw",
				"border-top-left-radius":"2.6vw",
				"border-top-right-radius":"2.6vw",
				"border-bottom-right-radius":"2.6vw",
				"border-bottom-left-radius":"2.6vw",
				"margin-top":"1vw",
				"align-items":"center",
				"flex-direction":"column",
				"justify-content":"center"
			}
		},
		{
			"selectors":[
				"#C7032f4e5-484f-47cd-a1f5-0d64741f595d"
			],
			"style":{
				"flex-direction":"row",
				"align-items":"center",
				"justify-content":"center",
				"align-self":"center",
				"text-align":"center",
				"display":"flex",
				"padding-top":"0.5vw",
				"padding-right":"1vw",
				"padding-bottom":"0.5vw",
				"padding-left":"1vw",
				"border-top-left-radius":"1.5vw",
				"border-top-right-radius":"1.5vw",
				"border-bottom-right-radius":"1.5vw",
				"border-bottom-left-radius":"1.5vw",
				"max-width":"76vw",
				"background":"rgba(30, 30, 30, 0.9)"
			}
		},
		{
			"selectors":[
				"#C7032f4e5-484f-47cd-a1f5-0d64741f595d-2"
			],
			"style":{
				"max-width":"76vw",
				"position":"absolute",
				"display":"flex",
				"flex-direction":"column",
				"align-items":"center",
				"justify-content":"flex-end",
				"width":"100%",
				"left":"calc(50% + 0vw)",
				"bottom":"2vw",
				"transform":"translateX(-50%)"
			}
		},
		{
			"selectors":[
				"Btn_SecondaryCTA"
			],
			"style":{
				"__background-type":"grad",
				"background-repeat":"repeat",
				"background-position":"left top",
				"background-attachment":"scroll",
				"background-size":"auto",
				"background-image":"linear-gradient(to top, #b4b4b4 86%, #d5d5d5 100%)",
				"position":"relative",
				"margin":"0vw 0.5vw 0vw 0vw",
				"width":"20vw"
			}
		},
		{
			"selectors":[
				"Btn_Primary_CTA"
			],
			"style":{
				"position":"relative",
				"width":"20vw"
			}
		},
		{
			"selectors":[
				{
					"name":"Btn_SecondaryTest",
					"active":false
				}
			],
			"style":{
				"width":"20vw",
				"border":"0vw none black"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"*",
			"style":{
				"font-family":"Roboto, Arial, sans-serif"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"::-webkit-scrollbar",
			"style":{
				"width":"10px",
				"height":"10px"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"::-webkit-scrollbar-track",
			"style":{
				"background-color":"rgb(51, 51, 51)"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"::-webkit-scrollbar-corner",
			"style":{
				"background-color":"rgb(51, 51, 51)"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"::-webkit-scrollbar-thumb",
			"style":{
				"background-color":"rgb(191, 191, 191)"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"::-webkit-scrollbar-thumb:hover",
			"style":{
				"background-color":"rgb(235, 235, 235)"
			}
		},
		{
			"selectors":[
				"primary-cta"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"20vw",
				"height":"4.5vw",
				"min-height":"4.5vw",
				"border-top-left-radius":"12vw",
				"border-top-right-radius":"12vw",
				"border-bottom-right-radius":"12vw",
				"border-bottom-left-radius":"12vw",
				"background-image":"linear-gradient(rgb(255, 255, 255) 0%, rgb(239, 239, 239) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"color":"rgb(48, 48, 48)",
				"font-size":"2vw",
				"box-shadow":"rgba(0, 0, 0, 0.4) 0px 0px 1vw 0px"
			}
		},
		{
			"selectors":[
				"primary-cta"
			],
			"style":{
				"transform":"scale(1.05, 1.05)"
			},
			"state":CssStates.Hover
		},
		{
			"selectors":[
				"primary-cta"
			],
			"style":{
				"background-image":"linear-gradient(rgb(255, 255, 255) 0%, rgb(239, 239, 239) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial"
			},
			"state":CssStates.Hover
		},
		{
			"selectors":[
				"secondary-cta"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"20vw",
				"height":"4.5vw",
				"min-height":"4.5vw",
				"border-top-left-radius":"12vw",
				"border-top-right-radius":"12vw",
				"border-bottom-right-radius":"12vw",
				"border-bottom-left-radius":"12vw",
				"background-image":"linear-gradient(rgb(118, 118, 118) 0%, rgb(79, 79, 79) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"color":"rgb(235, 235, 235)",
				"font-size":"2vw",
				"box-shadow":"rgba(0, 0, 0, 0.4) 0px 0px 1vw 0px"
			}
		},
		{
			"selectors":[
				"secondary-cta"
			],
			"style":{
				"transform":"scale(1.05, 1.05)"
			},
			"state":CssStates.Hover
		},
		{
			"selectors":[
				"secondary-cta"
			],
			"style":{
				"background-image":"linear-gradient(rgb(164, 164, 164) 0%, rgb(126, 126, 126) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial"
			},
			"state":CssStates.Active
		},
		{
			"selectors":[
				"primary-icon-cta"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"9vw",
				"height":"9vw",
				"background-color":"rgba(30, 30, 30, 0.8)",
				"border-top-left-radius":"50%",
				"border-top-right-radius":"50%",
				"border-bottom-right-radius":"50%",
				"border-bottom-left-radius":"50%"
			}
		},
		{
			"selectors":[
				"primary-icon-cta"
			],
			"style":{
				"transform":"scale(1.05, 1.05)"
			},
			"state":CssStates.Hover
		},
		{
			"selectors":[
				"primary-icon-cta"
			],
			"style":{
				"background-color":"rgb(89, 89, 89)"
			},
			"state":CssStates.Active
		},
		{
			"selectors":[
				"secondary-icon-cta"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"7.25vw",
				"height":"7.25vw",
				"background-color":"rgba(30, 30, 30, 0.8)",
				"border-top-left-radius":"50%",
				"border-top-right-radius":"50%",
				"border-bottom-right-radius":"50%",
				"border-bottom-left-radius":"50%"
			}
		},
		{
			"selectors":[
				"secondary-icon-cta"
			],
			"style":{
				"transform":"scale(1.05, 1.05)"
			},
			"state":CssStates.Hover
		},
		{
			"selectors":[
				"secondary-icon-cta"
			],
			"style":{
				"background-color":"rgb(89, 89, 89)"
			},
			"state":CssStates.Active
		},
		{
			"selectors":[
				"#C296b92bd-5996-49d2-bcc5-3189950d5cb3"
			],
			"style":{
				"font-family":"Arial, Helvetica, sans-serif",
				"font-size":"2.5vw",
				"color":"#ebebeb",
				"margin-top":"1.5vw",
				"margin-bottom":"0vw",
				"margin-left":"0vw",
				"margin-right":"0vw",
				"width":"100%",
				"text-align":"center",
				"font-weight":"700",
				"display":"none"
			}
		},
		{
			"selectors":[
				"#C791f1b2b-f08b-4445-8958-018908c5362e"
			],
			"style":{
				"justify-content":"center",
				"align-items":"center",
				"width":"auto",
				"height":"auto",
				"flex-direction":"column",
				"position":"absolute",
				"left":"1.5vw",
				"top":"calc(50% + 0vw)",
				"transform":"translateY(-50%)",
				"display":"none"
			}
		},
		{
			"selectors":[
				"#C0cc6aeeb-e838-4e9b-9db3-adbd7596f431"
			],
			"style":{
				"justify-content":"center",
				"align-items":"center",
				"height":"auto",
				"flex-direction":"column",
				"align-content":"center",
				"margin-top":"0vw",
				"margin-bottom":"1vw",
				"margin-left":"0vw",
				"margin-right":"0",
				"display":"flex"
			}
		},
		{
			"selectors":[
				"#Cc90915b2-830f-4f17-9e69-a0a9f1031ebd-2"
			],
			"style":{
				"height":"100%",
				"font-size":"2vw",
				"font-weight":"normal",
				"color":"#EBEBEB",
				"text-align":"left",
				"max-width":"12vw"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"div[data-gjs-type=\"wrapper\"]",
			"style":{
				"height":"100vh",
				"width":"100vw"
			}
		},
		{
			"selectors":[
				"#C4591f523-3a14-4aa0-83bc-81d7c825c29a"
			],
			"style":{
				"font-family":"'Roboto', 'Arial', sans-serif",
				"font-size":"1.5vw",
				"font-weight":"normal",
				"text-align":"left",
				"color":"rgba(235, 235, 235, 1)"
			}
		},
		{
			"selectors":[
				"visageEditorDefaultContainer"
			],
			"style":{
				"position":"relative",
				"width":"100%",
				"height":"100%",
				"display":"flex",
				"align-items":"center",
				"justify-content":"center"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"text",
			"style":{
				"display":"inline-block",
				"min-width":"1vw",
				"min-height":"1vw"
			}
		},
		{
			"selectors":[
				"primary-cta"
			],
			"style":{
				"background-image":"linear-gradient(rgb(255, 255, 255) 0%, rgb(239, 239, 239) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial"
			},
			"state":CssStates.Active
		},
		{
			"selectors":[
				"#C2eeddc4f-b36a-4140-8595-17bf3f19585e"
			],
			"style":{
				"position":"absolute",
				"bottom":"2vw",
				"left":"2vw",
				"background":"rgba(30, 30, 30, 0.9)",
				"border-top-left-radius":"3.625vw",
				"border-top-right-radius":"3.625vw",
				"border-bottom-right-radius":"3.625vw",
				"border-bottom-left-radius":"3.625vw",
				"display":"flex",
				"padding-bottom":"0.5vw"
			}
		},
		{
			"selectors":[
				"#C1f38140e-5ec9-4ead-be1b-da29bd38876f"
			],
			"style":{
				"width":"70%",
				"height":"70%"
			}
		},
		{
			"selectors":[
				"#C1055115a-0ad3-4e06-bcb4-307e2bdf122d"
			],
			"style":{
				"display":"flex",
				"position":"relative",
				"padding-left":"0.5vw",
				"padding-top":"0.5vw",
				"padding-right":"0.5vw",
				"padding-bottom":"0.5vw",
				"width":"100%",
				"background":"rgba(48, 48, 48, 1)",
				"align-items":"center",
				"flex-direction":"column",
				"justify-content":"center"
			}
		},
		{
			"selectors":[
				"#C759869e4-5c1f-400d-8739-afb9131ae592"
			],
			"style":{
				"font-family":"'Roboto', 'Arial', sans-serif",
				"font-size":"1.5vw",
				"font-weight":"normal",
				"text-align":"left",
				"color":"rgba(235, 235, 235, 1)"
			}
		},
		{
			"selectors":[
				"#C73e302cc-902c-413f-a533-49e94765fe5d"
			],
			"style":{
				"height":"100%",
				"font-size":"2vw",
				"font-weight":"normal",
				"color":"#EBEBEB",
				"text-align":"left",
				"max-width":"12vw"
			}
		},
		{
			"selectors":[
				"#C251c8854-7633-46f5-b5cb-bc190c0f4e64"
			],
			"style":{
				"font-family":"'Roboto', 'Arial', sans-serif",
				"font-size":"1.5vw",
				"font-weight":"normal",
				"text-align":"left",
				"color":"rgba(235, 235, 235, 1)"
			}
		},
		{
			"selectors":[
				"#Cf714e88a-6a9e-44ff-bf13-dc1956d61fb7"
			],
			"style":{
				"display":"flex",
				"position":"relative",
				"padding-left":"0.5vw",
				"padding-top":"0.5vw",
				"padding-right":"0.5vw",
				"padding-bottom":"0.5vw",
				"width":"100%",
				"background":"rgba(48, 48, 48, 1)",
				"align-items":"center",
				"flex-direction":"column",
				"justify-content":"center"
			}
		},
		{
			"selectors":[
				"#Cf714e88a-6a9e-44ff-bf13-dc1956d61fb7-2"
			],
			"style":{
				"justify-content":"center",
				"align-items":"center",
				"height":"auto",
				"flex-direction":"column",
				"align-content":"center",
				"margin-top":"0vw",
				"margin-bottom":"1vw",
				"margin-left":"0vw",
				"margin-right":"0",
				"display":"flex"
			}
		},
		{
			"selectors":[
				"#Cca874ff0-36e6-43f0-9c31-898b112dd820"
			],
			"style":{
				"position":"absolute",
				"right":"1.5vw",
				"top":"calc(50% + 0vw)",
				"transform":"translateY(-50%)",
				"display":"flex",
				"align-items":"center",
				"flex-direction":"column",
				"justify-content":"center",
				"width":"8.999583333333332vw",
				"height":"17.24898148148148vw"
			}
		},
		{
			"selectors":[
				"#C866537d7-df71-4f8f-99f6-ab5d66d70ab5"
			],
			"style":{
				"position":"absolute",
				"background":"rgba(30, 30, 30, 0.9)",
				"border-top-left-radius":"4.5vw",
				"border-top-right-radius":"4.5vw",
				"border-bottom-right-radius":"4.5vw",
				"border-bottom-left-radius":"4.5vw",
				"width":"9vw",
				"height":"9vw",
				"padding-left":"0.5vw",
				"margin-top":"0vw",
				"margin-bottom":"1vw",
				"margin-left":"0vw",
				"margin-right":"0vw",
				"padding-top":"1.5vw",
				"padding-bottom":"1.5vw",
				"top":"0vw",
				"left":"calc(50% + 0vw)",
				"transform":"translateX(-50%)"
			}
		},
		{
			"selectors":[
				"#Cd9e360d5-489c-43b4-9bdf-e5dfcba8d8e0"
			],
			"style":{
				"height":"100%"
			}
		},
		{
			"selectors":[
				"#Cac7fd1cc-bc8a-43de-9aa4-d96a550f4cb1"
			],
			"style":{
				"position":"absolute",
				"background":"rgba(30, 30, 30, 0.9)",
				"border-top-left-radius":"3.625vw",
				"border-top-right-radius":"3.625vw",
				"border-bottom-right-radius":"3.625vw",
				"border-bottom-left-radius":"3.625vw",
				"width":"7.25vw",
				"height":"7.25vw",
				"padding-right":"0.5vw",
				"padding-top":"1.25vw",
				"padding-bottom":"1.25vw",
				"left":"calc(50% + 0vw)",
				"bottom":"0vw",
				"transform":"translateX(-50%)"
			}
		},
		{
			"selectors":[
				"#Cf4d39326-c5ab-46d0-b9b4-8f8dbed7a6e4"
			],
			"style":{
				"height":"100%"
			}
		},
		{
			"selectors":[
				"#Ca22178d1-768f-4c6e-b3ef-0daf6dc01d34"
			],
			"style":{
				"font-family":"Arial, Helvetica, sans-serif",
				"font-size":"2vw",
				"color":"#ebebeb",
				"margin-top":"1.5vw",
				"margin-bottom":"0vw",
				"margin-left":"0vw",
				"margin-right":"0vw",
				"width":"100%",
				"text-align":"center"
			}
		},
		{
			"selectors":[
				"#C840075fb-fd26-4202-98c4-08c66549f3d0"
			],
			"style":{
				"display":"none",
				"flex-direction":"row",
				"justify-content":"flex-end",
				"margin-top":"1vw",
				"margin-bottom":"0",
				"margin-left":"0",
				"margin-right":"0",
				"align-items":"center"
			}
		},
		{
			"selectors":[
				"#C7227eeab-3688-41fc-a279-9ac5dd12d288"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"20vw",
				"height":"4.5vw",
				"min-height":"4.5vw",
				"border-top-left-radius":"12vw",
				"border-top-right-radius":"12vw",
				"border-bottom-right-radius":"12vw",
				"border-bottom-left-radius":"12vw",
				"background-image":"linear-gradient(rgb(118, 118, 118) 0%, rgb(79, 79, 79) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"color":"rgb(235, 235, 235)",
				"font-size":"2vw",
				"box-shadow":"rgba(0, 0, 0, 0.4) 0px 0px 1vw 0px",
				"background":"linear-gradient(0deg, RGB(70, 70, 70) 0%, rgba(102,102,102,1) 100%)",
				"margin-top":"0vw",
				"margin-bottom":"0vw",
				"margin-left":"0vw",
				"margin-right":"1vw"
			}
		},
		{
			"selectors":[
				"#Cdd0b845d-2d7a-4f0b-81db-180366709222"
			],
			"style":{
				"font-size":"2vw",
				"font-weight":"700",
				"color":"rgba(235, 235, 235, 1)"
			}
		},
		{
			"selectors":[
				"#C7b8ce5d0-60aa-40df-be5d-3a23838d824f"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"20vw",
				"height":"4.5vw",
				"min-height":"4.5vw",
				"border-top-left-radius":"12vw",
				"border-top-right-radius":"12vw",
				"border-bottom-right-radius":"12vw",
				"border-bottom-left-radius":"12vw",
				"background-image":"linear-gradient(rgb(255, 255, 255) 0%, rgb(239, 239, 239) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"color":"rgb(48, 48, 48)",
				"font-size":"2vw",
				"box-shadow":"rgba(0, 0, 0, 0.4) 0px 0px 1vw 0px",
				"background":"linear-gradient(0deg, RGB(197, 197, 197) 0%, rgba(241,241,241,1) 100%)",
				"margin-top":"0vw",
				"margin-bottom":"0vw",
				"margin-left":"1vw",
				"margin-right":"0vw"
			}
		},
		{
			"selectors":[
				"#Cf7a29ffc-7cd1-4b5e-b5f2-2189334fd2f9"
			],
			"style":{
				"font-size":"2vw",
				"font-weight":"700",
				"color":"rgba(48, 48, 48, 1)"
			}
		},
		{
			"selectors":[
				"#C6f1c200b-3d5d-4da5-b3a7-4af56523ab33"
			],
			"style":{
				"justify-content":"center",
				"align-items":"center",
				"width":"100%",
				"height":"6vw",
				"position":"absolute",
				"display":"none",
				"background":"rgba(30, 30, 30, 0.9)",
				"flex-direction":"row",
				"top":"0vw",
				"left":"calc(50% + 0vw)",
				"transform":"translateX(-50%)"
			}
		},
		{
			"selectors":[
				"#C634fe290-777b-40cf-a8dd-bc134a122ff5"
			],
			"style":{
				"width":"auto",
				"height":"70%",
				"font-size":"2vw",
				"font-weight":"normal",
				"color":"#EBEBEB",
				"text-align":"left"
			}
		},
		{
			"selectors":[
				"#C0334491e-5f0c-4b92-a8b0-16d079fc6d10"
			],
			"style":{
				"font-family":"'Roboto', 'Arial', sans-serif",
				"font-size":"2.5vw",
				"font-weight":"700",
				"text-align":"left",
				"color":"rgba(235, 235, 235, 1)",
				"margin-top":"0vw",
				"margin-bottom":"0vw",
				"margin-left":"1vw",
				"margin-right":"0vw"
			}
		}
	],
	"pages":[
		{
			"frames":[
				{
					"component":{
						"type":"wrapper",
						"stylable":[
							"background",
							"background",
							"background-image",
							"background-repeat",
							"background-attachment",
							"background-position",
							"background-size"
						],
						"attributes":{
							"id":"i5rl"
						},
						"components":[
							{
								"type":"div",
								"attributes":{
									"id":"Cf3d3d78b-3ad4-4afd-a1b7-b2fe41d9c616",
									"data-action":"",
									"data-no-actions":"",
									"data-not-deletable":"",
									"data-not-resizable":"",
									"data-not-copiable":""
								},
								"components":[
									{
										"type":"div",
										"name":"Container",
										"attributes":{
											"id":"C6f1c200b-3d5d-4da5-b3a7-4af56523ab33",
											"data-action":""
										},
										"components":[
											{
												"type":"image",
												"name":"Image",
												"resizable":{
													"ratioDefault":1
												},
												"attributes":{
													"id":"C634fe290-777b-40cf-a8dd-bc134a122ff5",
													"asset-id":"",
													"src":embeddedImagesBase64.scopeCube,
												}
											},
											{
												"type":"e-text",
												"name":"Text",
												"content":"Title",
												"attributes":{
													"id":"C0334491e-5f0c-4b92-a8b0-16d079fc6d10",
												}
											}
										],
										"custom-name":"Banner",
										"__prev-display":"flex"
									},
									{
										"type":"div",
										"name":"Empty Container",
										"attributes":{
											"id":"C791f1b2b-f08b-4445-8958-018908c5362e",
											"data-action":""
										},
										"components":[
											{
												"type":"div",
												"name":"Empty Container",
												"attributes":{
													"id":"C0cc6aeeb-e838-4e9b-9db3-adbd7596f431",
													"data-action":""
												},
												"components":[
													{
														"type":"image",
														"name":"Image",
														"resizable":{
															"ratioDefault":1
														},
														"attributes":{
															"id":"Cc90915b2-830f-4f17-9e69-a0a9f1031ebd-2",
															"src":embeddedImagesBase64.imagePlaceholder,
															"data-action":""
														}
													},
													{
														"type":"div",
														"name":"Empty Container",
														"attributes":{
															"id":"C1055115a-0ad3-4e06-bcb4-307e2bdf122d",
														},
														"components":[
															{
																"type":"e-text",
																"name":"Text",
																"content":"Caption",
																"attributes":{
																	"id":"C759869e4-5c1f-400d-8739-afb9131ae592",
																}
															}
														],
														"custom-name":"Caption Container"
													}
												],
												"custom-name":"Inset 1",
												"__prev-display":"flex"
											},
											{
												"type":"div",
												"name":"Empty Container",
												"attributes":{
													"id":"Cf714e88a-6a9e-44ff-bf13-dc1956d61fb7-2",
													"data-action":""
												},
												"components":[
													{
														"type":"image",
														"name":"Image",
														"resizable":{
															"ratioDefault":1
														},
														"attributes":{
															"id":"C73e302cc-902c-413f-a533-49e94765fe5d",
															"asset-id":"",
															"src":embeddedImagesBase64.imagePlaceholder,
															"data-action":""
														}
													},
													{
														"type":"div",
														"name":"Empty Container",
														"attributes":{
															"id":"Cf714e88a-6a9e-44ff-bf13-dc1956d61fb7",
														},
														"components":[
															{
																"type":"e-text",
																"name":"Text",
																"content":"Caption",
																"attributes":{
																	"id":"C251c8854-7633-46f5-b5cb-bc190c0f4e64",
																}
															}
														],
														"custom-name":"Caption Container"
													}
												],
												"custom-name":"Inset 2"
											}
										],
										"custom-name":"Insets",
										"__prev-display":"flex"
									},
									{
										"type":"div",
										"attributes":{
											"id":"C7032f4e5-484f-47cd-a1f5-0d64741f595d-2",
											"data-action":""
										},
										"components":[
											{
												"type":"div",
												"attributes":{
													"id":"C7032f4e5-484f-47cd-a1f5-0d64741f595d",
													"data-action":""
												},
												"components":[
													{
														"type":"e-text",
														"name":"Text",
														"content":"Step #StepNumber/#StepTotal - #StepName",
														"attributes":{
															"id":"C4591f523-3a14-4aa0-83bc-81d7c825c29a",
														}
													}
												],
												"custom-name":"Step Counter",
												"__prev-display":"flex"
											},
											{
												"type":"div",
												"attributes":{
													"id":"C021d6e69-2e9d-4922-8c7e-a6ee36772440-11",
													"data-action":""
												},
												"components":[
													{
														"type":"e-text",
														"content":"Title",
														"attributes":{
															"id":"C296b92bd-5996-49d2-bcc5-3189950d5cb3",
															"data-action":""
														},
														"custom-name":"Title"
													},
													{
														"type":"e-text",
														"content":"Description text goes here",
														"attributes":{
															"id":"Ca22178d1-768f-4c6e-b3ef-0daf6dc01d34",
															"data-action":"",
															[GjsAttributeNames.SmartIdentifier]:SmartIdentifierStates.Enabled,
														},
														"custom-name":"Description"
													},
													{
														"type":"div",
														"attributes":{
															"id":"C840075fb-fd26-4202-98c4-08c66549f3d0",
															"data-action":""
														},
														"components":[
															{
																"type":"div",
																"name":"Secondary Button",
																"classes":[
																	"secondary-cta"
																],
																"attributes":{
																	"id":"C7227eeab-3688-41fc-a279-9ac5dd12d288",
																	"asset-id":""
																},
																"components":[
																	{
																		"type":"e-text",
																		"name":"Label",
																		"content":"Cancel",
																		"attributes":{
																			"id":"Cdd0b845d-2d7a-4f0b-81db-180366709222",
																		}
																	}
																]
															},
															{
																"type":"div",
																"name":"Primary Button",
																"classes":[
																	"primary-cta"
																],
																"attributes":{
																	"id":"C7b8ce5d0-60aa-40df-be5d-3a23838d824f",
																	"asset-id":""
																},
																"components":[
																	{
																		"type":"e-text",
																		"name":"Label",
																		"content":"Accept",
																		"attributes":{
																			"id":"Cf7a29ffc-7cd1-4b5e-b5f2-2189334fd2f9",
																		}
																	}
																]
															}
														],
														"custom-name":"Buttons",
														"__prev-display":"flex"
													}
												],
												"custom-name":"Description Box",
												"__prev-display":"flex"
											}
										],
										"custom-name":"Description/Counter"
									},
									{
										"type":"div",
										"name":"Home Button",
										"classes":[
											"secondary-icon-cta"
										],
										"attributes":{
											"id":"C2eeddc4f-b36a-4140-8595-17bf3f19585e",
											"data-action":""
										},
										"components":[
											{
												"type":"image",
												"name":"Icon",
												"resizable":{
													"ratioDefault":1
												},
												"attributes":{
													"id":"C1f38140e-5ec9-4ead-be1b-da29bd38876f",
													"asset-id":"",
													"src":embeddedImagesBase64.home,
													"data-action":""
												}
											}
										]
									},
									{
										"type":"div",
										"attributes":{
											"id":"Cca874ff0-36e6-43f0-9c31-898b112dd820",
											"data-action":""
										},
										"components":[
											{
												"type":"div",
												"name":"Next Button",
												"classes":[
													"primary-icon-cta"
												],
												"attributes":{
													"id":"C866537d7-df71-4f8f-99f6-ab5d66d70ab5",
													"data-action":"next_step"
												},
												"components":[
													{
														"type":"image",
														"name":"Icon",
														"resizable":{
															"ratioDefault":1
														},
														"attributes":{
															"id":"Cd9e360d5-489c-43b4-9bdf-e5dfcba8d8e0",
															"asset-id":"",
															"src":embeddedImagesBase64.next,
														}
													}
												]
											},
											{
												"type":"div",
												"name":"Previous Button",
												"classes":[
													"secondary-icon-cta"
												],
												"attributes":{
													"id":"Cac7fd1cc-bc8a-43de-9aa4-d96a550f4cb1",
													"data-action":"previous_step"
												},
												"components":[
													{
														"type":"image",
														"name":"Icon",
														"resizable":{
															"ratioDefault":1
														},
														"attributes":{
															"id":"Cf4d39326-c5ab-46d0-b9b4-8f8dbed7a6e4",
															"asset-id":"",
															"src":embeddedImagesBase64.prev,
														}
													}
												]
											}
										],
										"custom-name":"Prev/Next Buttons",
										"__prev-display":"flex"
									}
								],
								"custom-name":"Template Container"
							}
						],
						"custom-name":"Content UI"
					},
					"id":"obpfjKarG4PgDgFS"
				}
			],
			"type":"main",
			"id":"kOCGgDvnkDAuSz8T"
		}
	]
};

export default GjsTemplateContent;